export default interface MetaData {
    companyAdmin: number,
    attributes: CompanyAttributes
}

export interface CompanyAttributes {
    companyName: string,
    active: boolean,
    international?: boolean,
    dateCreated?: string,
    logo?: string,
    priorityDealer?: boolean,
    allowLeads?: boolean,
    licenses?: License[]
}

export interface License {
    status: LicenseStatusType,
    stateCode: string,
    state: string,
    type: LicenseType,
    expirationDate: string,
  }

  export const LicenseTypes = ['LSV', 'Recreational'] as const;

  export type LicenseType = typeof LicenseTypes[number];

  export const LicenseStatusTypes = ['active', 'inactive'] as const;

  export type LicenseStatusType = typeof LicenseStatusTypes[number];
